import {
  Box,
  ButtonGroup,
  Stack
} from '@mui/material';
import { ReactNode } from 'react';



export type CompanyTabLayoutProps = {
  title?: string;
  buttonGroup?: ReactNode | ReactNode[];
  summaryMetric?: ReactNode;
  companyChart?: ReactNode;
  detailMetricSection?: ReactNode | ReactNode[];
};

export const FC = (props: CompanyTabLayoutProps) => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      rowGap='1rem'
      paddingTop='1rem'
      paddingBottom='2rem'
      marginBottom='2rem'
    >
      {/* TITLE */}
      <Stack
        direction='row'
        justifyContent='space-between'
      >
        {props.summaryMetric}

        {/* FILTERS */}
        <ButtonGroup
          size='small'
          variant='outlined'
          color='secondary'
          sx={{
            height: '1rem'
          }}
        >
          {props.buttonGroup}
        </ButtonGroup>
      </Stack>

      {/* CHART */}
      <Stack
        direction='row'
        columnGap='2.5rem'
      >
        {props.companyChart}
      </Stack>

      {/* SUMMARY SECTIONS */}
      <Stack
        direction='row'
        columnGap='2.5rem'
      >
        {props.detailMetricSection}
      </Stack>

    </Box>
  );

};
